export const SHOPIFY_CHECKOUT_ID_COOKIE = 'shopify_checkoutId'
export const SHOPIFY_CHECKOUT_URL_COOKIE = 'shopify_checkoutUrl'

export const SHOPIFY_CART_ID_COOKIE = 'shopify_cartId'
export const SHOPIFY_CART_URL_COOKIE = 'shopify_cartUrl'

export const SHOPIFY_CUSTOMER_TOKEN_COOKIE = 'shopify_customerToken'

export const STORE_DOMAIN = process.env.NEXT_PUBLIC_SHOPIFY_STORE_DOMAIN

export const SHOPIFY_GRAPHQL_API_VERSION = process.env.NEXT_PUBLIC_SHOPIFY_GRAPHQL_API_VERSION
export const SHOPIFY_REST_API_VERSION = process.env.NEXT_PUBLIC_SHOPIFY_REST_API_VERSION

export const SHOPIFY_COOKIE_EXPIRE = 15

export const API_URL = `https://${process.env.NEXT_PUBLIC_SHOPIFY_STOREFRONT_DOMAIN}/api/${SHOPIFY_GRAPHQL_API_VERSION}/graphql.json`

export const API_TOKEN = process.env.NEXT_PUBLIC_SHOPIFY_STOREFRONT_ACCESS_TOKEN
